<template>
  <div class="select-tab">
    <div class="text">
      {{ labelText.replace("_", " ") }}
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectTab",
  props: {
    labelText: String
  }
};
</script>

<style scoped></style>
